import { useTrack } from "@/hooks/useTrack/useTrack";
import { useTrackHelpers } from "@/hooks/useTrackHelpers/useTrackHelpers";
import { useCall } from "../useCall/useCall";

export function useTrackPause() {
  const { track } = useTrack();
  const { call } = useCall();

  const { transcription_displayed } = useTrackHelpers();

  const isVoicemail = call?.type === "voicemail";

  const onPause = () => {
    track(isVoicemail ? "voicemail_paused" : "recording_paused", {
      call_uuid: call?.uuid,
      call_id: call?.id,
      transcription_displayed,
    });
  };

  return { onPause };
}
